export default "__VITE_ASSET__Bookn5Uo__"